import React from "react";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import "./TheParentDashboard.css";

const getStatusClass = (status) => {
  switch (status) {
    case "Assigned":
      return "status-pill assigned";
    case "On Progress":
      return "status-pill progress";
    case "Finished":
      return "status-pill finished";
    default:
      return "status-pill";
  }
};

export default function StudentPapersStatus({ papers, parent_dashboard_initial_loading }) {
  return (
    <div className="student-papers-status">
      {!parent_dashboard_initial_loading && papers.length > 0 ? (
        papers?.map((paper, index) => (
          <div className="paper-row d-flex align-items-center" key={index}>
            <div className="paper-icon" aria-hidden="true">
              <DescriptionOutlinedIcon fontSize="small" />
            </div>
            <div className="paper-main flex-grow-1">
              <div className="paper-title">{paper?.assess_name || "N/A"}</div>
              <div className="paper-meta d-flex align-items-center">
                <span className="time-text">{paper?.time}</span>
              </div>
            </div>
            <div className={getStatusClass(paper.candidate_status)}>{paper.candidate_status || "N/A"}</div>
          </div>
        ))
      ) : (
        parent_dashboard_initial_loading ? (
          <>Loading...</>
        ) : (
          <>No Papers...</>
        )
      )}
    </div>
  );
}
